import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { defineMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { TextInput } from 'atoms/inputs/TextInput';
import { useShortcutWithKeys } from 'hooks/useShortcutWithKeys';
import { useToggle } from 'hooks/useToggle';

import { SearchBarDialog } from './SearchBarDialog';

const StyledTextInput = styled(TextInput)`
  background: rgba(var(--c-rgb-white), 0.04);
  border: 1px solid var(--c-nd-50);
  &,
  & * {
    text-align: left;
    cursor: pointer;
  }

  &:hover {
    border-color: var(--c-nd-150);
  }
  transition: 300ms border-color ease-in-out;
`;

const placeholder = defineMessage({
  id: 'SearchBar.placeholder',
  defaultMessage: 'Search...',
});

export const SearchBar = () => {
  const { formatMessage } = useIntl();
  const [searchDialogOpened, toggleSearchDialogOpened] = useToggle(false);

  const { Icon: searchShortcut } = useShortcutWithKeys(
    'cmdk',
    () => {
      toggleSearchDialogOpened();
    },
    [toggleSearchDialogOpened]
  );

  return (
    <>
      <StyledTextInput
        type="button"
        onClick={toggleSearchDialogOpened}
        startAdornment={
          <FontAwesomeIcon icon={faSearch} color="var(--c-nd-600)" />
        }
        value={formatMessage(placeholder)}
        endAdornment={searchShortcut}
      />
      {!!searchDialogOpened && (
        <SearchBarDialog onClose={() => toggleSearchDialogOpened()} />
      )}
    </>
  );
};
